import Vue from "vue";
import $ from "jquery";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { EventBus } from "../Controls/EventBus";
import EventConstants from "../Controls/EventConstants";
import { UtilisateurLightDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurLightDto";
import { SalarieLightDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieLightDto";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ImportDsnAutoDto } from "../../dto/GenApi.iNotPaie.Dto/ImportDsnAutoDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	components: {
		ModalDsn: require("../modalComponents/modalDsn/modalDsn.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as listeContratsRemplis);
			vm.fetchData();
			(v as listeContratsRemplis).getData();
		});
	},
	beforeRouteLeave(to, from, next) {
		next();
	}
})
export default class listeContratsRemplis extends Vue {
	public dataReady = false;
	// Contrats: ContratAutoRemplisDto[] = [];
	public ImportDsn?: ImportDsnAutoDto;
	//* * Les listes des combos **//
	public utilisateurs: UtilisateurLightDto[] = [];
	public listeManagers: SalarieLightDto[] = [];
	public listeNatureContrats: ParametreDto[] = [];
	public listeTypeContrats: ParametreDto[] = [];
	public listeConventionCollectives: ParametreDto[] = [];
	public listeClassifications: ParametreDto[] = [];
	public listeCodeInsees: ParametreDto[] = [];
	public listeDureeContrats: ParametreDto[] = [];
	public listeMaladieRetraites: ParametreDto[] = [];

	public receptionContrats(importDsn: ImportDsnAutoDto): void {
    	this.ImportDsn = importDsn;
	}

	public fetchData(): void {
        this.dataReady = false;
    	ServicesFactoryInstance.UtilisateursService.getUtilisateurs(data => {
    		this.utilisateurs = data;
    	});
    	ServicesFactoryInstance.ParametresService.getNatureContrats(data => {
    		this.listeNatureContrats = data;
    	});
    	ServicesFactoryInstance.ParametresService.getTypeContrats(data => {
    		this.listeTypeContrats = data;
    	});
    	ServicesFactoryInstance.ParametresService.getClassifications(false, data => {
    		this.listeClassifications = data;
    	});
    	ServicesFactoryInstance.ParametresService.getCodeInsees(data => {
    		this.listeCodeInsees = data;
    	});
    	ServicesFactoryInstance.ParametresService.getConventionsCollectives(data => {
    		this.listeConventionCollectives = data;
    	});
    	ServicesFactoryInstance.ParametresService.getDureeContrats(data => {
    		this.listeDureeContrats = data;
    	});
    	ServicesFactoryInstance.ParametresService.getMaladieRetraites(false, data => {
    		this.listeMaladieRetraites = data;
    	});
    	this.dataReady = true;
	}

	public getData(): void {
    	if (this.ImportDsn == undefined || this.ImportDsn.ListeContratsAutoRemplis.length == 0) {
			$("#modalDsn").modal("show");
		}
	}

	public oncontratsCrees(data: ImportDsnAutoDto): void {
    	this.dataReady = false;
    	this.ImportDsn = data;

    	for (let i = 0; i < this.ImportDsn.ListeContratsAutoRemplis.length; i++) {
    		const manager: SalarieLightDto = {
                Id: 0,
                IdSociete: 0,
    			Nom: this.ImportDsn.ListeContratsAutoRemplis[i].Nom,
    			Prenom: this.ImportDsn.ListeContratsAutoRemplis[i].Prenom,
    			NumSecu: this.ImportDsn.ListeContratsAutoRemplis[i].NSecuriteSociale
    		};
    		this.listeManagers.push(manager);
    	}

    	this.dataReady = true;
	}

	public isEmpty(value: any): boolean {
    	return (value == null || value.length === 0);
	}

	public annuler(): void {
    	this.ImportDsn = undefined;
        EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
        this.dataReady = false;
	}

	public valider(): void {
		if (this.ImportDsn == undefined) {
			return;
		}

    	this.dataReady = false;
    	ServicesFactoryInstance.ContratAutoFromDsnService.CreateFromImportDsn(this.ImportDsn, () => {
    		this.ImportDsn = undefined;
    		EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
    		EventBus.NavigateTo({ path: "/listeSalaries/" });
    		this.dataReady = true;
    		NotificationServiceInstance.SendSuccess("Le traitement s'est terminé avec succès.");
    	}, () => {
    		this.dataReady = true;
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/contratAutoFromDsn/contratAutoFromDsn.ts